import styled from "@emotion/styled";

export const OnboardingContainer = styled.div`
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 688px;
  padding: 0px 24px;
  overflow: auto;
  position: relative;
`;
